/**
 * @generated SignedSource<<87c6690f3c3000d388db078b2c518e5b>>
 * @relayHash 6112b84e247d2745efa4000b963b08c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 83f40f13e1220fb297a796d2d31afc41145eb98526eea1572e780ca576797f18

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type AccountStatus = "active" | "closed" | "inactive" | "%future added value";
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdateSingleSelectUserPickerFieldInput = {
  id: string;
  operation: JiraSingleSelectUserPickerFieldOperationInput;
};
export type JiraSingleSelectUserPickerFieldOperationInput = {
  accountId?: string | null | undefined;
  id?: string | null | undefined;
  operation: JiraSingleValueFieldOperations;
};
export type assignToMeInlineEdit_Mutation$variables = {
  input: JiraUpdateSingleSelectUserPickerFieldInput;
};
export type assignToMeInlineEdit_Mutation$data = {
  readonly jira: {
    readonly updateSingleSelectUserPickerField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly user: {
          readonly accountId: string;
          readonly accountStatus: AccountStatus;
          readonly id: string;
          readonly name: string;
          readonly picture: AGG$URL;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type assignToMeInlineEdit_Mutation$rawResponse = {
  readonly jira: {
    readonly updateSingleSelectUserPickerField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly id: string;
        readonly user: {
          readonly __typename: string;
          readonly accountId: string;
          readonly accountStatus: AccountStatus;
          readonly id: string;
          readonly name: string;
          readonly picture: AGG$URL;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type assignToMeInlineEdit_Mutation = {
  rawResponse: assignToMeInlineEdit_Mutation$rawResponse;
  response: assignToMeInlineEdit_Mutation$data;
  variables: assignToMeInlineEdit_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "picture"
},
v7 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "assignToMeInlineEdit_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
            "kind": "LinkedField",
            "name": "updateSingleSelectUserPickerField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraSingleSelectUserPickerField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "assignToMeInlineEdit_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
            "kind": "LinkedField",
            "name": "updateSingleSelectUserPickerField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraSingleSelectUserPickerField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ]
                  },
                  (v8/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "83f40f13e1220fb297a796d2d31afc41145eb98526eea1572e780ca576797f18",
    "metadata": {},
    "name": "assignToMeInlineEdit_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c173f35125cc6125a23783b5ebaf48b4";

export default node;
